<template>
  <div class="pr-4">
    <!-- Branded wordmark, matching the Figma "Time line" concept. -->
    <h1 class="text-3xl font-light lowercase text-white tracking-wide">
      {{ $t("timeline.wordmark") }}
    </h1>

    <!-- Decorative subway-line motif (concept placeholder). -->
    <svg
      class="mt-8 w-full max-w-2xl h-auto text-highlight"
      viewBox="0 0 640 380"
      fill="none"
      role="img"
      :aria-label="$t('nav.timeline')"
    >
      <!-- Top-left short segments: o | ——   o——o——o -->
      <g stroke="currentColor" stroke-width="6" stroke-linecap="round">
        <line x1="36" y1="34" x2="36" y2="78" />
        <line x1="36" y1="56" x2="98" y2="56" />
        <line x1="200" y1="56" x2="320" y2="56" />
      </g>
      <g stroke="currentColor" stroke-width="3" fill="#292B3A">
        <circle cx="14" cy="56" r="6" />
        <circle cx="200" cy="56" r="6" />
        <circle cx="260" cy="56" r="6" />
        <circle cx="320" cy="56" r="6" />
      </g>

      <!-- Main T-shaped line -->
      <g stroke="currentColor" stroke-width="12" stroke-linecap="round">
        <line x1="28" y1="300" x2="452" y2="300" />
        <line x1="240" y1="300" x2="240" y2="152" />
      </g>

      <!-- Stations -->
      <g fill="#FFFFFF" stroke="currentColor" stroke-width="6">
        <circle cx="108" cy="300" r="20" />
        <circle cx="240" cy="300" r="20" />
        <circle cx="372" cy="300" r="20" />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "Timeline",
};
</script>
